import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { PlayerProvider } from "@/context/PlayerContext";
import { PurchaseProvider } from "@/context/PurchaseContext";
import { WishlistProvider } from "@/context/WishlistContext";
import { AuthDialog } from "@/components/AuthDialog";
import { AudioPlayer } from "@/components/AudioPlayer";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Library from "@/pages/Library";
import Wishlist from "@/pages/Wishlist";
import Admin from "@/pages/Admin";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import SoldArchive from "@/pages/SoldArchive";
import EarlyAccess from "@/pages/EarlyAccess";
import RefundPolicy from "@/pages/RefundPolicy";
import TermsOfService from "@/pages/TermsOfService";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import { ScrollToTop } from "@/components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <PlayerProvider>
            <PurchaseProvider>
              <WishlistProvider>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/purchases" element={<Library />} />
                  <Route path="/library" element={<Library />} />
                  <Route path="/wishlist" element={<Wishlist />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="/checkout/success" element={<CheckoutSuccess />} />
                  <Route path="/sold" element={<SoldArchive />} />
                  <Route path="/early/:id" element={<EarlyAccess />} />
                  <Route path="/refund-policy" element={<RefundPolicy />} />
                  <Route path="/terms" element={<TermsOfService />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                <AudioPlayer />
                <AuthDialog />
                <Toaster theme="dark" position="top-center" />
              </WishlistProvider>
            </PurchaseProvider>
          </PlayerProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
